/**
 *
 * @export
 * @interface Terminal
 */
export interface Terminal {
  /**
   * terminal device or user id
   * @type {string}
   * @memberof Terminal
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof Terminal
   */
  platform?: TerminalPlatformEnum;
  /**
   * terminal online session
   * @type {string}
   * @memberof Terminal
   */
  sessionId?: string;
  /**
   *
   * @type {string}
   * @memberof Terminal
   */
  type?: TerminalTypeEnum;
}

export const TerminalPlatformEnum = {
  UnknownPlatform: 'unknown_platform',
  And: 'and',
  Ios: 'ios',
  Web: 'web',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TerminalPlatformEnum = (typeof TerminalPlatformEnum)[keyof typeof TerminalPlatformEnum];
export const TerminalTypeEnum = {
  UnknownType: 'unknown_type',
  User: 'user',
  Device: 'device',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TerminalTypeEnum = (typeof TerminalTypeEnum)[keyof typeof TerminalTypeEnum];
